import { Box, CircularProgress, Grid, Typography, Select, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import OrderItem from 'src/components/OrderItem';
import { IOrder } from 'src/function/ordersService';
import { RootState } from 'src/interface/IRootState';

interface OrdersPageProps {
  loading: boolean;
}

const OrdersPage: React.FC<OrdersPageProps> = ({ loading }) => {
  const [orderFilterValue, setOrderFilterValue] = useState<string>('AllOrder');
  const navigate = useNavigate();

  const orders = useSelector((state: RootState) => state.orders.orders);
  const userData = useSelector((state: RootState) => state.userData);

  const handleChangeOrdersFilterValue = (event: any) => {
    setOrderFilterValue(event.target.value);
  };

  const handleClickOrderItem = (order: IOrder) => {
    navigate(`/transaction/${order.socketId}`, { state: userData.telegramId })
  };

  const statusFilterMap = {
    Processed: ['WaitPayment', 'PaidBuyer', 'Dispute'],
    Completed: ['Canceled', 'Done', 'Fail'],
  };

  const filteredOrders = orders.filter(order => {
    if (orderFilterValue === 'AllOrder') return true;
    return statusFilterMap[orderFilterValue]?.includes(order.statusOrder);
  });

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px' }}>
      <Grid container justifyContent="center" spacing={3} direction="column">
        <Grid item xs={12} sm={8} md={6}>
          <Select sx={{ width: '200px' }} value={orderFilterValue} onChange={handleChangeOrdersFilterValue}>
            <MenuItem value="Processed">Ожидают выполнения</MenuItem>
            <MenuItem value="Completed">Завершенные</MenuItem>
            <MenuItem value="AllOrder">Все ордера</MenuItem>
          </Select>
        </Grid>

        <Grid item xs={12} sm={8} md={6}>
          <Box
            sx={{
              maxHeight: '80vh', // Обмеження по висоті екрану
              height: {
                xs: '60vh', // Для малих екранів контейнер займатиме 60% висоти екрану
                sm: '70vh', // Для середніх — 70%
                md: '80vh', // Для великих — 80%
              },
              overflowY: 'auto',
              paddingTop: '10px',
              paddingBottom: '20px',
            }}
          >
            {filteredOrders.length > 0 ? (
              filteredOrders.map(order => (
                <Box key={order._id} sx={{ marginBottom: '15px' }}>
                  <OrderItem order={order} onClick={() => handleClickOrderItem(order)} />
                </Box>
              ))
            ) : (
              <Typography align="center" variant="h6" color="textSecondary">
                Пока этот список пуст
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrdersPage;
